__turbopack_context__.v({
  "description": "lVfrpq_description",
  "list": "lVfrpq_list",
  "listHeader": "lVfrpq_listHeader",
});
